import { useCountUp } from '@/hooks/useCountUp';

const CountUpStats = () => {
  const { count: count1000, ref: ref1000 } = useCountUp(1000, 2500);
  const { count: count7, ref: ref7 } = useCountUp(7, 2000);
  const { count: count2, ref: ref2 } = useCountUp(2, 1500);
  const { count: count2000, ref: ref2000 } = useCountUp(2000, 2500);

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 text-center">
        <div ref={ref1000}>
          <div className="text-3xl md:text-4xl font-bold gradient-text mb-3 md:mb-4">
            {count1000}
          </div>
          <div className="text-white text-base md:text-lg">Bokser planlagt på 3 år</div>
        </div>
        <div ref={ref7}>
          <div className="text-3xl md:text-4xl font-bold gradient-text mb-3 md:mb-4">
            {count7}
          </div>
          <div className="text-white text-base md:text-lg">Måneder til utsolgt</div>
        </div>
        <div ref={ref2}>
          <div className="text-3xl md:text-4xl font-bold gradient-text mb-3 md:mb-4">
            {count2}
          </div>
          <div className="text-white text-base md:text-lg">År på rad utsolgt til jul</div>
        </div>
        <div ref={ref2000}>
          <div className="text-3xl md:text-4xl font-bold gradient-text mb-3 md:mb-4">
            {count2000}+
          </div>
          <div className="text-white text-base md:text-lg">Bokser solgt</div>
        </div>
      </div>

      <div className="mt-8 md:mt-12 text-center">
        <p className="text-base sm:text-lg md:text-xl text-white/90 leading-relaxed">
          Den første PWO-en kom i mai 2023. Planen var å selge tusen bokser på tre år mens Jesper studerte; fasiten ble utsolgt til jul – to år på rad. Familien som først tilbød penger for å stoppe prosjektet, ber nå om rabattkode. Spenst Førde, kompiser fra Forsvaret og en sak i Firda ga ekstra fart.
        </p>
        
        <blockquote className="text-lg sm:text-xl md:text-2xl text-white font-bold mt-6 md:mt-8 italic">
          "2024 startet ironisk nok med tomme hyller, men det bekreftet bare poenget: når du lager noe skikkelig, forsvinner det fort."
        </blockquote>
      </div>
    </>
  );
};

export default CountUpStats;
